import { render, staticRenderFns } from "./SmsComposeModal.vue?vue&type=template&id=5a6cd74c"
import script from "./SmsComposeModal.vue?vue&type=script&lang=js"
export * from "./SmsComposeModal.vue?vue&type=script&lang=js"
import style0 from "./SmsComposeModal.vue?vue&type=style&index=0&id=5a6cd74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports